'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkContentBlockCenter.module.css';

export function DevlinkContentBlockCenter({
  as: _Component = _Builtin.Section,
  showEyebrowText = true,
  eyebrowText = 'EYEBROW',
  headline = 'Headline',
  showBodyText = true,
  bodyText = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus',
  showButtons = true,
  buttons,
  hasLightBgColor = true,
  hasLightBgBlob = true,
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'position-relative')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'large-1')} tag="div" />
        <_Builtin.Block className={_utils.cx(_styles, 'ht-contained-hero-centered')} tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-contained-hero-content')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-hero-content', 'center')} tag="div">
              {showEyebrowText ? (
                <_Builtin.Block tag="div">
                  <_Builtin.Block className={_utils.cx(_styles, 'overline-text-sm')} tag="div">
                    {eyebrowText}
                  </_Builtin.Block>
                  <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
                </_Builtin.Block>
              ) : null}
              <_Builtin.Heading className={_utils.cx(_styles, 'txt-header')} tag="h3">
                {headline}
              </_Builtin.Heading>
              {showBodyText ? (
                <_Builtin.Block tag="div">
                  <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
                  <_Builtin.Paragraph className={_utils.cx(_styles, 'p1')}>{bodyText}</_Builtin.Paragraph>
                </_Builtin.Block>
              ) : null}
              {showButtons ? (
                <_Builtin.Block tag="div">
                  <_Builtin.Block className={_utils.cx(_styles, 'small-2')} tag="div" />
                  <_Builtin.Block className={_utils.cx(_styles, 'ht-button-group', 'centered')} tag="div">
                    {buttons}
                  </_Builtin.Block>
                </_Builtin.Block>
              ) : null}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'large-1')} tag="div" />
      </_Builtin.Block>
      {hasLightBgBlob ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-bg-fill-container')} tag="div">
          <_Builtin.Image
            className={_utils.cx(_styles, 'ht-content-block-blob')}
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6604b7b8a05937fb1181845c_meet-tech-blob.svg"
          />
        </_Builtin.Block>
      ) : null}
      {hasLightBgColor ? <_Builtin.Block className={_utils.cx(_styles, 'ht-bg-color', 'bg-n050')} tag="div" /> : null}
    </_Component>
  );
}
